import styled from "styled-components";

// dls
import { GenericIcon } from "@swiggy-private/dls-web-icons/dist/GenericIconWeb";

const VIEW_ALL_REWARDS_VERTICAL_PADDING = "18px";

export const ViewAllRewardsContainer = styled.div(({ theme }) => {
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: `${VIEW_ALL_REWARDS_VERTICAL_PADDING} ${theme.spacing.medium}`,
    };
});

export const IconWrapper = styled.div(({ theme }) => {
    return {
        width: theme.spacing.xLarge,
        height: theme.spacing.xLarge,
    };
});

export const Icon = styled(GenericIcon)(() => {
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
    };
});
